module.exports = __webpack_public_path__ + "img/46.zone_is_clean.92ca862d.svg";